module.exports = __webpack_public_path__ + "img/LeastConnections.af388be6.gif";